import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { UsersRound, HeartPulse, TrafficCone, Goal, LandPlot } from "lucide-react";

const Stat = ({ icon: Icon, label, value, color }) => (
  <div className="glass border border-[#d1fae5] rounded-2xl p-5 hover:border-[#2a3b19]/40 transition-colors">
    <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-3 ${color}`}>
      <Icon size={22} />
    </div>
    <div className="text-3xl font-black">{value}</div>
    <div className="text-sm text-slate-600 mt-1">{label}</div>
  </div>
);

export default function Dashboard() {
  const [stats, setStats] = useState({ players: 0, injured: 0, trainings: 0, matches: 0 });
  const [club, setClub] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/project").then(({ data }) => setClub(data.club_name)).catch(() => {});
  }, []);

  const cards = [
    { to: "/players", label: "اللاعبون", value: stats.players, icon: UsersRound, color: "bg-[#2a3b19]/10 text-[#2a3b19]" },
    { to: "/players", label: "لاعبون مصابون", value: stats.injured, icon: HeartPulse, color: "bg-red-500/15 text-red-500" },
    { to: "/training", label: "الحصص التدريبية", value: stats.trainings, icon: TrafficCone, color: "bg-[#2a3b19]/10 text-[#2a3b19]" },
    { to: "/matches", label: "المباريات", value: stats.matches, icon: Goal, color: "bg-[#2a3b19]/10 text-[#2a3b19]" },
  ];

  return (
    <div>
      <div className="mb-8">
        <p className="text-xs font-medium text-[#2a3b19] uppercase tracking-wider">لوحة التحكم</p>
        <h1 className="text-3xl font-black mt-1">{club || "الفريق"}</h1>
        <p className="text-slate-600 mt-1">نظرة عامة على أداء الفريق وإدارته</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c, i) => (
          <button key={i} data-testid={`dashboard-stat-${i}`} onClick={() => navigate(c.to)} className="text-right">
            <Stat {...c} />
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-8">
        {[
          { to: "/players", label: "إدارة اللاعبين", desc: "ملفات اللاعبين وتقييماتهم", icon: UsersRound },
          { to: "/training", label: "الحصص التدريبية", desc: "الحضور والخطط والتقييمات", icon: TrafficCone },
          { to: "/matches", label: "المباريات", desc: "التشكيلات والأحداث والنتائج", icon: Goal },
          { to: "/tactics", label: "التشكيلات التكتيكية", desc: "بناء الخطط على الملعب", icon: LandPlot },
        ].map((q, i) => (
          <button
            key={i}
            data-testid={`quick-link-${i}`}
            onClick={() => navigate(q.to)}
            className="glass border border-[#d1fae5] rounded-2xl p-5 flex items-center gap-4 hover:border-[#2a3b19]/50 transition-colors text-right"
          >
            <div className="w-12 h-12 rounded-xl bg-[#ecfdf5] flex items-center justify-center">
              <q.icon size={22} className="text-[#2a3b19]" />
            </div>
            <div>
              <div className="font-bold">{q.label}</div>
              <div className="text-sm text-slate-600">{q.desc}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
